import { render, staticRenderFns } from "./accredit.vue?vue&type=template&id=f101004c&scoped=true"
import script from "./accredit.vue?vue&type=script&lang=js"
export * from "./accredit.vue?vue&type=script&lang=js"
import style0 from "./accredit.vue?vue&type=style&index=0&id=f101004c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f101004c",
  null
  
)

export default component.exports